import script from "./ProductListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductListView.vue?vue&type=script&setup=true&lang=ts"

import "./ProductListView.vue?vue&type=style&index=0&id=5d5b060c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5b060c"]])

export default __exports__